(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._modal_eygw8_1{width:400px}.AvatarCropper-base{text-align:center}.AvatarCropper-base input[type=range]{-webkit-appearance:none;border:1px solid #fff;width:400px;padding:20px 0;display:inline-block}.AvatarCropper-base input[type=range]::-webkit-slider-runnable-track{background:#ddd;border:none;border-radius:3px;width:400px;height:5px}.AvatarCropper-base input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;background:#454545;border:none;border-radius:50%;width:16px;height:16px;margin-top:-4px}.AvatarCropper-base input[type=range]:focus{outline:none}.AvatarCropper-base input[type=range]:focus::-webkit-slider-runnable-track{background:#ccc}.AvatarCropper-base input[type=range]::-moz-range-track{background:#ddd;border:none;border-radius:3px;width:400px;height:5px}.AvatarCropper-base input[type=range]::-moz-range-thumb{background:#454545;border:none;border-radius:50%;width:16px;height:16px}.AvatarCropper-base input[type=range]:-moz-focusring{outline-offset:-1px;outline:1px solid #fff}.AvatarCropper-base input[type=range]::-ms-track{color:#0000;background:0 0;border-width:6px 0;border-color:#0000;width:400px;height:5px}.AvatarCropper-base input[type=range]::-ms-fill-lower{background:#777;border-radius:10px}.AvatarCropper-base input[type=range]::-ms-fill-upper{background:#ddd;border-radius:10px}.AvatarCropper-base input[type=range]::-ms-thumb{background:#454545;border:none;border-radius:50%;width:16px;height:16px}.AvatarCropper-base input[type=range]:focus::-ms-fill-lower{background:#888}.AvatarCropper-base input[type=range]:focus::-ms-fill-upper{background:#ccc}.AvatarCropper-base canvas{cursor:move}._root_1gylt_1{width:100%;display:block}._inner_1gylt_6{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import { Button as e, FlexBox as t, Modal as n, ModalBody as r } from "@dixa/lib-shared-habla";
import { Component as i, useCallback as a, useLayoutEffect as o, useMemo as s, useRef as c, useState as l } from "react";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
import f from "classnames";
import p from "moment-timezone";
var m = { modal: "_modal_eygw8_1" };
//#endregion
//#region src/components/avatarCropper/components/cropper.tsx
function h(e) {
	return !!e.match(/^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i);
}
var g = ({ imageUri: n, width: r = 400, height: i = 400, onRequestHide: s, onCrop: f, closeButtonCopy: p, cropButtonCopy: m }) => {
	let g = c(null), _ = c(null), v = c(!1), y = c({
		x: null,
		y: null
	}), b = c(1), [x, S] = l(null), [C, w] = l(1), T = a(() => {
		if (g.current && x) {
			let e = g.current.getContext("2d");
			if (!e) throw Error("Failed to create a 2D context in avatar cropper.");
			e.clearRect(0, 0, r, i), I(e, x);
		}
	}, [
		x,
		r,
		i,
		C
	]), E = ({ currentImage: e, x: t, y: n, dx: a, dy: o }) => {
		let s = t - a, c = n - o, l = b.current, u = e.width * l, d = (u - e.width) / 2, f = r, p;
		p = s - d > 0 ? d : s < -u + f ? f - u : s;
		let m = e.height * l, h = (m - e.height) / 2, g = i, _;
		return _ = c - h > 0 ? h : c < -m + g ? g - m : c, {
			x: p,
			y: _
		};
	};
	o(() => {
		O(n);
		let e = g.current;
		return window.addEventListener("mousemove", M, !1), window.addEventListener("mouseup", j, !1), e && e.addEventListener("mousedown", k, !1), document.onselectstart = (e) => A(e), () => {
			window.removeEventListener("mousemove", M), window.removeEventListener("mouseup", j), e && e.removeEventListener("mousedown", k);
		};
	}, []), o(() => {
		T();
	}, [T]);
	function D(e, t) {
		let n, a;
		return i / r > t / e ? (n = i, a = n / t * e) : (a = r, n = a / e * t), {
			width: a,
			height: n
		};
	}
	function O(e) {
		let t = new Image();
		h(e) || (t.crossOrigin = "anonymous"), t.onload = () => {
			let e = {
				...D(t.width, t.height),
				resource: t,
				x: 0,
				y: 0
			};
			v.current = !1, S(e);
		}, t.src = e;
	}
	let k = () => {
		v.current = !0, y.current = {
			x: null,
			y: null
		};
	}, A = (e) => {
		if (v.current) return e.preventDefault(), !1;
	}, j = () => {
		v.current = !1;
	}, M = (e) => {
		if (!v.current) return;
		let t = e.clientX, n = e.clientY;
		if (y.current.x !== null && y.current.y !== null) {
			let e = y.current.x - t, r = y.current.y - n;
			S((t) => {
				if (t === null) return null;
				let n = E({
					currentImage: t,
					x: t.x,
					y: t.y,
					dx: e,
					dy: r
				});
				return {
					...t,
					x: n.x,
					y: n.y
				};
			});
		}
		y.current = {
			x: t,
			y: n
		};
	}, N = () => {
		if (x === null) throw Error("Image not defined in toDataURL.");
		let e = document.createElement("canvas"), t = e.getContext("2d");
		if (!t) throw Error("Failed to create a 2D canvas context at toDataURL.");
		return e.width = r, e.height = i, I(t, {
			resource: x.resource,
			x: x.x,
			y: x.y,
			height: x.height,
			width: x.width
		}), e.toDataURL();
	}, P = () => {
		f(N());
	}, F = () => {
		if (_.current) {
			let e = parseFloat(_.current.value);
			b.current = e, w(e);
		}
	}, I = (e, t) => {
		if (!t.resource) return;
		e.save(), e.globalCompositeOperation = "destination-over";
		let n = t.width * C, a = t.height * C, o = t.x - (n - t.width) / 2, s = t.y - (a - t.height) / 2;
		o = Math.min(o, 0), s = Math.min(s, 0), s = a + s >= i ? s : s + (i - (a + s)), o = n + o >= r ? o : o + (r - (n + o)), e.drawImage(t.resource, o, s, t.width * C, t.height * C), e.restore();
	};
	return /* @__PURE__ */ d(t, {
		flexDirection: "column",
		gap: "300",
		className: "AvatarCropper-canvas",
		children: [
			/* @__PURE__ */ u("canvas", {
				ref: g,
				width: r,
				height: i
			}),
			/* @__PURE__ */ u("input", {
				type: "range",
				name: "zoom",
				ref: _,
				onChange: F,
				style: { width: r },
				min: "1",
				max: "3",
				step: "0.01",
				defaultValue: "1"
			}),
			/* @__PURE__ */ d(t, {
				gap: "300",
				justifyContent: "flex-end",
				children: [/* @__PURE__ */ u(e, {
					variant: "secondary",
					onClick: s,
					children: p
				}), /* @__PURE__ */ u(e, {
					variant: "primary",
					onClick: P,
					children: m
				})]
			})
		]
	});
}, _ = ({ cropperOpen: e, image: i, onCrop: a, onRequestHide: o, closeButtonCopy: s = "Close", cropButtonCopy: c = "Crop and Save" }) => i ? /* @__PURE__ */ u(n, {
	isOpen: e,
	onClose: o,
	className: m.modal,
	children: /* @__PURE__ */ u(r, { children: /* @__PURE__ */ u(t, {
		justifyContent: "center",
		className: "AvatarCropper-base",
		children: /* @__PURE__ */ u(g, {
			imageUri: i,
			width: 200,
			height: 200,
			onCrop: a,
			onRequestHide: o,
			closeButtonCopy: s,
			cropButtonCopy: c
		})
	}) })
}) : null, v = {
	root: "_root_1gylt_1",
	inner: "_inner_1gylt_6"
}, y = ({ children: e, min: t, max: n, className: r, ...i }) => {
	let d = c(null), p = c(null), [m, h] = l(0), [g, _] = l(!0), [y, b] = l(0), [x, S] = l(0), C = a(() => {
		if (!d.current || !p.current) return;
		let e = p.current, r = d.current.offsetWidth, i = parseFloat(window.getComputedStyle(e, null).getPropertyValue("font-size")) / e.scrollWidth * r - 2;
		h(Math.max(t ?? 0, Math.min(i, n ?? i))), _(!0);
	}, [n, t]), w = s(() => new window.ResizeObserver((e) => {
		requestAnimationFrame(() => {
			if (e[0]) {
				let { width: t } = e[0].contentRect;
				S(t);
			}
		});
	}), []);
	return o(() => {
		if (d.current) return w.observe(d.current), () => {
			w.disconnect();
		};
	}, [w]), o(() => {
		x !== y && (b(x), _(!1));
	}, [x, y]), o(() => {
		g || C();
	}, [g, C]), o(() => {
		_(!1);
	}, [e]), /* @__PURE__ */ u("div", {
		ref: d,
		className: f(v.root, r),
		...i,
		children: /* @__PURE__ */ u("span", {
			ref: p,
			className: v.inner,
			style: {
				fontSize: m > 0 ? `${m}px` : "inherit",
				display: g ? "block" : "inline-block"
			},
			children: e
		})
	});
}, b = class extends i {
	static defaultProps;
	constructor(e) {
		super(e), this._tick = this._tick.bind(this), this._stop = this._stop.bind(this), this._format = this._format.bind(this), this.state = {
			counter: 0,
			interval: null
		};
	}
	UNSAFE_componentWillMount() {
		if (this.props.startAt !== null && this.props.asCounter === !1) {
			let e = p().utc().diff(p(this.props.startAt));
			e = e > 0 ? e : 0;
			let t = parseInt(e / 1e3, 10);
			this.setState({ counter: t });
		}
		if (this.props.startAt !== null && this.props.asCounter === !0 && this.setState({ counter: this.props.startAt }), this.props.start === !0 && this.props.startAt !== null && this.state.interval === null) {
			let e = window.setInterval(this._tick, 1e3);
			this.setState({ interval: e });
		}
	}
	UNSAFE_componentWillReceiveProps(e) {
		if (e.startAt === null && this.state.counter !== 0) this.state.interval !== null && window.clearInterval(this.state.interval), this.setState({
			interval: null,
			counter: 0
		});
		else if (e.startAt !== null && this.props.startAt !== e.startAt) {
			let t, n;
			this.props.asCounter === !1 ? (t = p().utc().diff(p(e.startAt)), n = parseInt(t / 1e3, 10)) : n = e.startAt, this.setState({ counter: n }, () => {
				if (e.start && this.state.interval === null) {
					let e = window.setInterval(this._tick, 1e3);
					this.setState({ interval: e });
				}
			});
		}
	}
	componentWillUnmount() {
		this.state.interval !== null && window.clearInterval(this.state.interval), this.setState({
			interval: null,
			counter: 0
		});
	}
	_tick() {
		this.setState({ counter: this.state.counter + 1 });
	}
	_stop() {
		this.state.interval !== null && window.clearInterval(this.state.interval), this.setState({ interval: null });
	}
	_format(e) {
		return p(e * 1e3).utc().format("HH:mm:ss");
	}
	render() {
		let e = null, t = this._format(this.state.counter), n = "", r = parseInt(this.state.counter / 86400, 10);
		return r > 0 && (n = r === 1 ? r + " day " : r + " days "), e = this.props.textFitProps ? /* @__PURE__ */ u(y, {
			...this.props.textFitProps,
			children: `${n} ${t}`
		}) : `${n} ${t}`, /* @__PURE__ */ u("span", {
			className: "timer",
			children: e
		});
	}
};
b.defaultProps = {
	start: !0,
	startAt: null,
	asCounter: !1
};
//#endregion
//#region src/components/timer/CountDownTimer.tsx
var x = class extends i {
	static defaultProps;
	constructor(e) {
		super(e), this._tick = this._tick.bind(this), this._stop = this._stop.bind(this), this._format = this._format.bind(this), this.state = {
			counter: 0,
			interval: null
		};
	}
	UNSAFE_componentWillMount() {
		let e = this.props.startAt / 1e3;
		if (this.setState({ counter: e }), this.state.interval === null) {
			let e = window.setInterval(this._tick, 1e3);
			this.setState({ interval: e });
		}
	}
	UNSAFE_componentWillReceiveProps(e) {
		if (this.props.startAt !== e.startAt) {
			let t = e.startAt / 1e3;
			this.setState({ counter: t }, () => {
				if (this.state.interval === null) {
					let e = window.setInterval(this._tick, 1e3);
					this.setState({ interval: e });
				}
			});
		}
	}
	componentWillUnmount() {
		this.state.interval !== null && window.clearInterval(this.state.interval), this.setState({
			interval: null,
			counter: 0
		});
	}
	_tick() {
		let e = this.state.counter - 1;
		e > 0 ? this.setState({ counter: e }) : this._stop();
	}
	_stop() {
		this.state.interval !== null && window.clearInterval(this.state.interval), this.setState({ interval: null });
	}
	_format(e) {
		return p(e * 1e3).utc().format("HH:mm:ss");
	}
	render() {
		let e, t = this._format(this.state.counter);
		return e = this.props.textfit === !0 ? /* @__PURE__ */ u(y, {
			max: 30,
			children: t
		}) : t, /* @__PURE__ */ u("span", {
			className: "timer",
			children: e
		});
	}
};
x.defaultProps = {
	startAt: 0,
	textfit: !1
};
//#endregion
export { _ as AvatarCropper, x as CountDownTimer, y as TextFit, b as Timer };

//# sourceMappingURL=index.js.map